import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL || '';

const api = axios.create({ baseURL: BASE });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('ebios_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('ebios_token');
      localStorage.removeItem('ebios_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const authApi = {
  register:   (data)           => api.post('/api/auth/register', data).then(r => r.data),
  login:      (data)           => api.post('/api/auth/login', data).then(r => r.data),
  mfaLogin:   (data)           => api.post('/api/auth/mfa-login', data).then(r => r.data),
  me:         ()               => api.get('/api/auth/me').then(r => r.data),
};

export const mfaApi = {
  setup:      ()               => api.post('/api/mfa/setup').then(r => r.data),
  confirm:    (token)          => api.post('/api/mfa/confirm', { token }).then(r => r.data),
  disable:    (password)       => api.post('/api/mfa/disable', { password }).then(r => r.data),
  status:     ()               => api.get('/api/mfa/status').then(r => r.data),
};

export const projectApi = {
  list:       ()               => api.get('/api/projects').then(r => r.data),
  get:        (id)             => api.get(`/api/projects/${id}`).then(r => r.data),
  create:     (data)           => api.post('/api/projects', data).then(r => r.data),
  update:     (id, data)       => api.put(`/api/projects/${id}`, data).then(r => r.data),
  delete:     (id)             => api.delete(`/api/projects/${id}`).then(r => r.data),
  share:      (id)             => api.post(`/api/projects/${id}/share`).then(r => r.data),
  getShared:  (token)          => axios.get(`${BASE}/api/shared/${token}`).then(r => r.data),
};
